import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { responsive } from "../../utils/responsive";

export const cardStyle = style({
  overflow: "hidden",
  outlineOffset: "-1px",
});

export const contentStyle = style({
  minHeight: rem(200),
});

export const innerCardStyle = style({
  flexDirection: "column",
  ...responsive({
    s: {
      flexDirection: "row",
    },
  }),
});

export const innerContentStyle = style({
  display: "flex",
  gap: theme.spacings.s,
  flexDirection: "column",
});

export const imageStyle = style({
  width: "100%",
  height: rem(200),
  backgroundSize: "cover",
  backgroundPosition: "center",

  ...responsive({
    s: {
      height: "100%",
      width: rem(200),
    },
  }),
});

export const iconEdgeStyle = style({
  alignSelf: "flex-end",
});

export const titleStyles = recipe({
  variants: {
    hasHover: {
      true: {
        textDecoration: "underline",
      },
    },
  },
});
